<template>
    <v-layout>
        <v-flex xs5 class="mt-5">
            <canvas id="payment" height="400" style="width: 100%"></canvas>
        </v-flex>
        <v-spacer/>
        <v-flex xs5 class="mt-5">
            <canvas id="bonus" height="400" style="width: 100%"></canvas>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'orderPayment',
        props: ['dataPayment'],
        mounted () {
            let ctx = document.getElementById('payment').getContext('2d')
            let cbx = document.getElementById('bonus').getContext('2d')

            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Оплата'],
                    datasets: [
                        {
                            label: 'Наличные',
                            data: [this.dataPayment.payment_cash],
                            backgroundColor: ['#968f00'],
                        },
                        {
                            label: 'Без наличных',
                            data: [this.dataPayment.payment_no_cash],
                            backgroundColor: ['#00f0c8']
                        }
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: 'Статистика оплаты'
                    }
                }
            })

            new Chart(cbx, {
                type: 'bar',
                data: {
                    labels: ['Баллы'],
                    datasets: [
                        {
                            label: 'Частично оплачен баллами',
                            data: [this.dataPayment.payed_with_bonus],
                            backgroundColor: ['#520094']
                        },
                        {
                            label: 'Без использование баллов',
                            data: [this.dataPayment.payed_without_bonus],
                            backgroundColor: ['#4b9400']
                        }
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: 'Статистика оплаты баллами'
                    }
                }
            })
        }
    }
</script>
